module.exports = __webpack_public_path__ + "img/enging_room_pic01.762aafe8.png";